import { render, staticRenderFns } from "./editBlog.vue?vue&type=template&id=3c5268fa&scoped=true&lang=html&"
import script from "./editBlog.vue?vue&type=script&lang=js&"
export * from "./editBlog.vue?vue&type=script&lang=js&"
import style0 from "./editBlog.vue?vue&type=style&index=0&id=3c5268fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5268fa",
  null
  
)

export default component.exports